<!-- 拼团订单列表 -->
<template>
  <div class="my-game-list">
    <div v-show="isData" class="list-item">
      <MyGameCard v-for="(item, index) in gameInfo" :key="index" :gameInfo="item"></MyGameCard>
    </div>
    <div v-show="!isData" class="emptyData">
      <EmptyData emptyName="noGame" />
    </div>
  </div>
</template>

<script>
import { reqMyGameList } from '@/api/personal';
import EmptyData from '@/components/emptyData/emptyData.vue';
import MyGameCard from '@/pages/personalCenter/myActivity/game/GameCard.vue';

export default {
  data() {
    return {
      add: false,
      orderParam: {
        pageNum: 1,
        pageSize: 20,
      },
      loading: false,
      finished: false,
      refreshing: false, // 下拉刷新
      groupList: [],
      finishTotal: 0,
      isData: false,
      gameInfo: {},
    };
  },

  components: {
    EmptyData,
    MyGameCard,
  },

  computed: {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      window['iqhApp2jsBridge.triggerSC'].reload = this.init;
    }, 100);
  },
  created() {
    this.getGameList(this.orderParam);
  },
  methods: {
    //app返回后数据更新
    init(mode) {
      this.getGameList(this.orderParam);
    },
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.groupList.length >= this.finishTotal) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.orderParam.pageNum += 1;
        this.getGameList(this.orderParam);
      }
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      // this.groupList = [];
      this.refreshing = true;
      this.orderParam.pageNum = 1;
      this.getGameList(this.orderParam);
    },

    // eslint-disable-next-line consistent-return
    async getGameList() {
      this.loading = true;
      let gamelist = [0, 1];
      const res = await reqMyGameList(gamelist);
      this.loading = false;
      if (res.code === 0 && res?.data?.length > 0) {
        this.isData = true;
        this.gameInfo = res?.data;
      } else {
        this.isData = false;
      }
    },
    // 进入详情页
    courseDetails(orderNo) {
      this.$sendToApp('goOrderDetail', orderNo);
      this.$router.push({ path: '/indentDetail', query: { orderNo } });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-game-list {
  .list-item {
    width: 100%;
    margin-top: 29px;
    padding-bottom: 100px;
  }
  .empty {
    width: 100%;
    height: 100px;
  }
}
</style>
